import { Store } from 'redux';
import { EventHandler, setEventEmitter } from './eventEmitters';
import { AppActions, AppState } from '../../store/initialStateRegistration';

declare global {
    interface Window {
        mmClientApi?: Array<any> | { push: (eventName: string, params: any) => void };
        __mmClientApiSubscriptions__?: Map<string, any>;
    }
}

export const GET_PAGE_DATA = 'getPageData' as const;
export const INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY = 'injectArticleBlockByIndexArray' as const;
export const INJECT_VIDEO_LOGO = 'injectVideoLogo' as const;
export const INJECT_BUTTON_TO_FOOTER_LINKS_SECTION = 'injectButtonToFooterLinksSection' as const;

type ClientAPIEventNames = typeof GET_PAGE_DATA | typeof INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY | typeof INJECT_VIDEO_LOGO | typeof INJECT_BUTTON_TO_FOOTER_LINKS_SECTION;

export interface ClientAPIEvent {
    name: ClientAPIEventNames;
    handlerCreator: (store: Store<AppState, AppActions>) => EventHandler;
}

const isNewChunk = (index: number, chunkSize: number) => index % chunkSize === 0;

const getSubscribedEventsInChuncks = (items: any[], chunkSize: number) => {
    let currentChunk: any[] = [];
    return items.reduce((chunks: any[][], item, index) => {
        if (isNewChunk(index, chunkSize)) {
            currentChunk = [item];
            chunks.push(currentChunk);
        } else {
            currentChunk.push(item);
        }
        return chunks;
    }, []);
};

const handleEvent = (eventName: string, params: any) => {
    if (!window.__mmClientApiSubscriptions__) {
        window.__mmClientApiSubscriptions__ = new Map();
    }
    if (!window.__mmClientApiSubscriptions__.get(eventName)) {
        window.__mmClientApiSubscriptions__.set(eventName, []);
    }
    window.__mmClientApiSubscriptions__.get(eventName).push(params);
};

export const initClientApi = (clientAPIEvents: Array<ClientAPIEvent>, store: Store<AppState, AppActions>) => {
    if (window.mmClientApi) {
        getSubscribedEventsInChuncks((window.mmClientApi as Array<any>), 2).forEach(([eventName, params]) => handleEvent(eventName, params));
    }
    window.mmClientApi = {
        push: (eventName: string, params: any) => handleEvent(eventName, params),
    };
    clientAPIEvents.forEach(({ name, handlerCreator }) => setEventEmitter(name, handlerCreator(store)));
};
